export default __webpack_public_path__ + "static/media/QuizCorner.16bd73b2b9f97e63295e6e1e97f7542d.webp";